import React, { useCallback, useRef } from 'react';
import {
  IconButton,
  InputAdornment,
  makeStyles,
  TableCell,
  TextField
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';

import {
  CustomInputEvent,
  CustomKeyboardEvent,
  TransactionPayment
} from 'src/types';

interface Props {
  data: TransactionPayment;
  index: number;
  onSave: (
    e: any,
    item: TransactionPayment,
    field: 'transfer_fee' | 'acknowledgement_receipt_no'
  ) => void;
  onChangeText: (e: CustomInputEvent, index: number) => void;
}

const useStyles = makeStyles(
  {
    saveIcon: {
      padding: 0
    },
    input: {
      paddingTop: 0,
      height: 25,
      fontSize: '0.875rem'
    },
    adornment: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      fontSize: '0.875rem'
    }
  },
  { index: 999 }
);

const TransferFeeCell = ({ data, index, onSave, onChangeText }: Props) => {
  const inputRef = useRef([]);
  const classes = useStyles();

  const onKeyDown = useCallback(
    (e: CustomKeyboardEvent, item: TransactionPayment) => {
      if (e.key === 'Enter') {
        onSave(e, item, 'transfer_fee');
      }
    },
    [onSave]
  );

  return (
    <TableCell onClick={(e) => e.stopPropagation()}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          ref={inputRef.current[index]}
          className={classes.input}
          onFocus={(e) => {
            e.stopPropagation();
          }}
          size="small"
          variant="outlined"
          name="transfer_fee"
          type="number"
          onChange={(e) => onChangeText(e, index)}
          onKeyDown={(e) => onKeyDown(e, data)}
          value={data?.transfer_fee}
          InputProps={{
            className: classes.input,
            startAdornment: (
              <InputAdornment position="start" style={{ userSelect: 'none' }}>
                <span className={classes.adornment}>₱</span>
              </InputAdornment>
            ),
            endAdornment: (
              <IconButton
                className={classes.saveIcon}
                onClick={(e) => onSave(e, data, 'transfer_fee')}
              >
                <SaveIcon />
              </IconButton>
            )
          }}
        />
      </div>
    </TableCell>
  );
};

export const TransferFeeTableCell = React.memo(TransferFeeCell);
